module.exports = __webpack_public_path__ + "img/estonia.9c32da2c.png";